import { graphql } from "@/lib/gql/__generated__/gql";

export const DeleteRoomMutation = graphql(/* GraphQL */ `
	mutation RoomDelete($hotelID: ID!, $roomId: ID!) {
		roomDelete(hotelID: $hotelID, roomID: $roomId) {
			userErrors
			message
		}
	}
`);
